module.exports = __webpack_public_path__ + "static/media/decimal-icon.e9612aa7.svg";